(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("temporal-wms", [], factory);
	else if(typeof exports === 'object')
		exports["temporal-wms"] = factory();
	else
		root["temporal-wms"] = factory();
})(self, function() {
return 